// React
import React from 'react';

// Vendors
import { Outlet, Navigate } from 'react-router-dom';

// Src
import { useAuthentication } from '@/domain/authentication/hooks/useAuthentication';

const UnprotectedRoute = () => {
    // Hooks
    const { loggedIn } = useAuthentication();

    if (loggedIn) {
        return <Navigate to="/" />;
    }

    return <Outlet />;
};

export default UnprotectedRoute;
